export default {
  page: "Checkout"
};
